<rt-input
  #phoneInput
  [placeholder]="placeholder"
  (valueChange)="onInput($event)"
  (keydown)="onKeydown($event)"
  class="phone-field"
>
  <ng-container *ngTemplateOutlet="countrySelect" prefix></ng-container>
</rt-input>

<ng-template #countrySelect>
  <rt-select
    [hasSearch]="true"
    [options]="options"
    [optionTemplate]="countryOptionTemplate"
    [triggerTemplate]="triggerTemplate"
    [value]="selectedCountry?.code"
    [minDropdownWidth]="380"
    [dropdownPositions]="dropdownPositions"
    (valueChange)="onCountrySelect($event)"
    class="country-select"
  >
  </rt-select>
</ng-template>

<ng-template
  #triggerTemplate
  let-selectedOption="selectedOption"
  let-dropdownOpened="dropdownOpened"
  let-toggleDropdown="toggleDropdown"
>
  <rt-button variant="plain" [dropdownOpened]="dropdownOpened" (click)="toggleDropdown(true)">
    @if (selectedOption?.value) {
      <div class="iti__flag" [class]="getCountryFlag(selectedOption?.value)"></div>
    } @else {
      <div layout-justify-center class="no-country-code">
        <rt-icon name="remove" colorToken="colorIconLowDefault" size="small-xx"></rt-icon>
      </div>
    }
  </rt-button>
</ng-template>

<ng-template #countryOptionTemplate let-option="option">
  <div layout-horizontal layout-align-items-center layout-no-wrap>
    <div class="iti__flag" [class]="getCountryFlag(option?.value)" margin-right-small-x></div>
    <rt-truncate margin-right-small-x>
      {{ option.label }}
    </rt-truncate>
    <span class="dial-code">+{{ option.countryCode }}</span>
  </div>
</ng-template>
